import { render, staticRenderFns } from "./Zakat_paid.vue?vue&type=template&id=fdcfa9de&scoped=true"
import script from "./Zakat_paid.vue?vue&type=script&lang=js"
export * from "./Zakat_paid.vue?vue&type=script&lang=js"
import style0 from "./Zakat_paid.vue?vue&type=style&index=0&id=fdcfa9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcfa9de",
  null
  
)

export default component.exports